import React from 'react'
import { useUpdateNotifierLogic } from './UpdateNotifier.logic'
import UpdateNotifierView from './UpdateNotifier.view'

function UpdateNotifier() {
  const logicResults = useUpdateNotifierLogic()
  return <UpdateNotifierView {...logicResults} />
}

export default UpdateNotifier
